import {deleteRoadmapCoverImage} from '../actions/roadmaps'
import store from '../store'


export function removeRoadmapCoverImage(roadmapId) {
	store.dispatch(deleteRoadmapCoverImage(roadmapId))
}

